import React, { useState } from "react";
import { Box, Button, Icon, Stack, Text } from "@storyofams/react-ui";
import { CustomCheckbox } from "~components/common/CustomCheckbox";
import {
  AlternativeIngr,
  ArrowDown,
  ArrowUp,
  Fase,
  Percents,
} from "~components/common/Icons";
import { useRecipeCart } from "./CartProvider";

export const IngredientItem = React.memo(({ product, setNewProduct }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const { ingredientsToCart, setIngredients } = useRecipeCart();
  const [isAlternativeOpen, setIsAlternativeOpen] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(product);
  const [alternativeProducts, setAlternativeProducts] = useState(
    product.alternativeIds
  );
  const isPicked = ingredientsToCart.find(
    (item) => item.id === currentProduct.id
  );
  const handleAddToCart = () => {
    if (!currentProduct.availableForSale) return;
    if (isPicked)
      setIngredients([
        ...ingredientsToCart.filter((item) => item.id !== currentProduct.id),
      ]);
    else setIngredients([...ingredientsToCart, currentProduct]);
  };
  const handleClick = (alt) => {
    const newProduct = { ...currentProduct, ...alt };
    setAlternativeProducts((items) => [
      ...items.filter((item) => item.id !== alt.id),
      currentProduct,
    ]);
    setIsAlternativeOpen(false);
    if (newProduct.availableForSale && isPicked)
      setIngredients([
        ...ingredientsToCart.filter((item) => item.id !== currentProduct.id),
        newProduct,
      ]);
    else
      setIngredients([
        ...ingredientsToCart.filter((item) => item.id !== currentProduct.id),
      ]);
    setCurrentProduct(newProduct);
    setNewProduct(currentProduct, newProduct);
  };
  return (
    <Box
      p={["8px", "7.5px 8px"]}
      width={"100%"}
      borderTop={"1px solid #E2DFDF"}
      position={"relative"}
      overflow={"visible"}
    >
      <Box
        width={"100%"}
        display={"flex"}
        alignItems={"flex-start"}
        justifyContent={"space-between"}
        onClick={() => {
          setIsOpen((open) => !open);
          setIsAlternativeOpen(false);
        }}
        cursor={"pointer"}
      >
        <Box display={"flex"}>
          <Box
            border={"1px solid #E2DFDF"}
            onClick={(e) => {
              e.stopPropagation();
              handleAddToCart();
            }}
            backgroundColor={!currentProduct.availableForSale && "#E2DFDF"}
            width={20}
            borderRadius={"3px"}
            overflow={"hidden"}
            cursor={
              !currentProduct.availableForSale ? "not-allowed" : "pointer"
            }
            height={20}
            mr={["6px", "10px"]}
            flexShrink={0}
          >
            {currentProduct.availableForSale && (
              <CustomCheckbox checked={isPicked} />
            )}
          </Box>
          <Text
            fontWeight={500}
            color={"#1D1D1B"}
            fontSize={["14px", "16px"]}
            lineHeight={["19.6px", "22.4px"]}
            textAlign={"end"}
            mr={["6px", "10px"]}
            width={["34px", "40px"]}
            flexShrink={0}
          >
            {(currentProduct.gram || 0) + "g"}
          </Text>
          <Box>
            <Button
              as="a"
              target="_blank"
              onClick={(e) => e.stopPropagation()}
              href={`/products/${currentProduct.handle}`}
            >
              <Text
                fontWeight={500}
                color={"#1D1D1B"}
                fontSize={["14px", "16px"]}
                lineHeight={["19.6px", "22.4px"]}
                opacity={!currentProduct.availableForSale && 0.5}
                textAlign={"start"}
                mr={"10px"}
                minWidth={"40px"}
                css={{
                  "&:hover": { cursor: "pointer", textDecoration: "underline" },
                }}
              >
                {currentProduct.title}
              </Text>
            </Button>
            {!currentProduct.availableForSale && (
              <Box
                bg={"#EEE3D7"}
                mr={"10px"}
                mt={1}
                display={["block", "none"]}
                borderRadius="md"
                border={"1px solid grey200"}
                px="5px"
                width="86px"
                height={"17px"}
                position={"relative"}
              >
                <Text
                  position={"absolute"}
                  as="span"
                  fontSize={"10px"}
                  top={"1px"}
                  fontWeight={700}
                  letterSpacing={"0.1em"}
                  css={{ textTransform: "uppercase" }}
                >
                  Uitverkocht
                </Text>
              </Box>
            )}
          </Box>
        </Box>
        <Box display={"flex"} alignItems={"center"} flexShrink={0}>
          {!currentProduct.availableForSale && (
            <Box
              bg={"#EEE3D7"}
              mr={"10px"}
              display={["none", "block"]}
              borderRadius="md"
              border={"1px solid grey200"}
              px="5px"
              width="86px"
              height={"17px"}
              position={"relative"}
            >
              <Text
                position={"absolute"}
                as="span"
                fontSize={"10px"}
                top={"1px"}
                fontWeight={700}
                letterSpacing={"0.1em"}
                css={{ textTransform: "uppercase" }}
              >
                Uitverkocht
              </Text>
            </Box>
          )}
          <Box
            border={"1px solid #E2DFDF"}
            backgroundColor={"#FCF9F7"}
            width={24}
            borderRadius={"6px"}
            overflow={"hidden"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            cursor={"pointer"}
            height={24}
          >
            <Icon fontSize={2} icon={isOpen ? ArrowUp : ArrowDown} />
          </Box>
        </Box>
      </Box>
      {isOpen && (
        <>
          <Box
            mt={1}
            display={"flex"}
            alignItems={["start", "center"]}
            justifyContent={"space-between"}
            flexDirection={["column", "row"]}
            width={"100%"}
          >
            <Box
              backgroundColor={"#FCF9F7"}
              px="12px"
              height={["54px", "28px"]}
              ml={["65px", "80px"]}
              width={["calc(100% - 65px)", "240px"]}
              justifyContent={["center", "space-between"]}
              borderRadius={"6px"}
              display={"flex"}
              alignItems={["start", "center"]}
              fontSize={"14px"}
              flexDirection={["column", "row"]}
              lineHeight={"19.6px"}
            >
              <Box display={"flex"} alignItems={"center"}>
                <Icon mr={"6px"} fontSize={2} icon={Percents} />
                <Text mr={"6px"} color="#767473">
                  Percentage:
                </Text>
                <Text fontWeight={500} color="#1D1D1BCC">
                  {currentProduct.percents}%
                </Text>
              </Box>

              <Box display={"flex"} alignItems={"center"} mt={[1, 0]}>
                <Icon fontSize={2} mr={"6px"} icon={Fase}></Icon>
                <Text mr={"6px"} color="#767473">
                  Fase:
                </Text>
                <Text fontWeight={500} color="#1D1D1BCC">
                  {currentProduct.fase}
                </Text>
              </Box>
            </Box>
            <Stack
              mt={["8.5px", 0]}
              space={1}
              alignItems={"center"}
              ml={["65px", 0]}
            >
              <Text color="#767473" fontSize={"12px"} lineHeight={"16.8px"}>
                {currentProduct.variantTitle}
              </Text>
              <Text
                opacity={0.7}
                color="#767473"
                fontSize={"18px"}
                lineHeight={"16.8px"}
              >
                •
              </Text>
              <Text
                color="#1D1D1B"
                fontSize={["14px", "16px"]}
                lineHeight={["19.6px", "22.4px"]}
              >
                {"€" + currentProduct.price}
              </Text>
            </Stack>
          </Box>
          {alternativeProducts && !!alternativeProducts.length && (
            <Box
              mt={1}
              ml={["65px", "80px"]}
              width={["calc(100% - 65px)", "240px"]}
              cursor={"pointer"}
              onClick={() => setIsAlternativeOpen((open) => !open)}
            >
              <Stack
                backgroundColor={"#FCF9F7"}
                height={"28px"}
                alignItems={"center"}
                borderRadius={"6px"}
                border={"1px solid #E2DFDF"}
                justifyContent={"center"}
                space={"6px"}
              >
                <Icon fontSize={"20px"} icon={AlternativeIngr}></Icon>
                <Text
                  color="#1D1D1B"
                  fontSize={"12px"}
                  lineHeight={"16.8px"}
                  fontWeight={500}
                  pb="1px"
                >
                  Vervang door alternatief
                </Text>
                <Icon icon={isAlternativeOpen ? ArrowUp : ArrowDown}></Icon>
              </Stack>
            </Box>
          )}
        </>
      )}
      {isAlternativeOpen && (
        <Box
          width={["97%", "93%"]}
          left={0}
          right={0}
          position={"absolute"}
          mx={"auto"}
          backgroundColor={"#FCF9F7"}
          borderRadius={"6px"}
          mt={"3px"}
          border="1px solid #E2DFDF"
          zIndex={999}
          boxShadow="3px 3px 20px 0px #0000001A"
        >
          {alternativeProducts.map((item, i) => (
            <Box
              display={"flex"}
              key={i}
              justifyContent={"space-between"}
              alignItems={["start", "center"]}
              onClick={() => handleClick(item)}
              cursor={"pointer"}
              px="10px"
              py={["8px", "9px"]}
              borderTop={i && "1px solid #E2DFDF"}
              flexDirection={["column", "row"]}
            >
              <Text
                fontWeight={500}
                color={"#1D1D1B"}
                fontSize={["14px", "16px"]}
                lineHeight={["19.6px", "22.4px"]}
              >
                {item.title}
              </Text>
              <Stack space={1} alignItems={"center"}>
                <Text color="#767473" fontSize={"12px"} lineHeight={"16.8px"}>
                  {item?.variantTitle}
                </Text>
                <Text
                  opacity={0.7}
                  color="#767473"
                  fontSize={"18px"}
                  lineHeight={"16.8px"}
                >
                  •
                </Text>
                <Text
                  color="#1D1D1B"
                  fontSize={["14px", "16px"]}
                  lineHeight={["19.6px", "22.4px"]}
                >
                  {"€" + item.price}
                </Text>
              </Stack>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
});
